// @flow

const hideColumnsForNonRepUsers = (columns: any) => {
  return columns.map((i: any) => {
    if (i.binding === 'Rep') {
      return {
        ...i,
        visible: false,
      };
    }

    return i;
  });
};

export { hideColumnsForNonRepUsers };
